import egsPsLogo from "@/assets/logo-egs-ps.png";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Steps from "./steps";
import CompanyData from "./steps/company-data";
import MainContact from "./steps/main-contact";
import SuccessfulRegister from "./steps/successful-register";

interface MainContactI {
  name: string;
  lastname: string;
  email: string;
  phone: string;
}

const RegisterNewCompanyPage = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [name, setName] = useState("");
  const [ruc, setRuc] = useState("");
  const [tradeName, setTradeName] = useState("");
  const [address, setAddress] = useState("");
  const [website, setWebsite] = useState("");
  const [mainContact, setMainContact] = useState<MainContactI>({
    name: "",
    lastname: "",
    email: "",
    phone: "",
  });
  const [token, setToken] = useState<string | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [decodedToken, setDecodedToken] = useState<any>(null);
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search); // location.search contiene la query string
    const tokenFromUrl = urlParams.get("token");
    setToken(tokenFromUrl);

    if (tokenFromUrl) {
      try {
        const decoded = jwtDecode(tokenFromUrl);
        setDecodedToken(decoded);
      } catch (error) {
        console.error("Error decodificando el token:", error);
      }
    }
  }, [location]);

  useEffect(() => {
    if (decodedToken) {
      setRuc(decodedToken?.tax_id ?? "");
    }
  }, [decodedToken]);

  return (
    <div className="mx-auto px-14 py-8">
      <img
        className="mx-auto mb-12"
        src={egsPsLogo}
        width={220}
        alt="Logotipo Empresa con Gestión Sostenible"
      />
      <p className="mb-2 text-center text-xl font-semibold">Registro</p>
      <p className="text-balance text-center font-light">
        Te damos la bienvenida a la plataforma EGS. Llena los datos de la
        empresa y tus datos para inscribirte en la plataforma.
      </p>
      <Steps currentStep={currentStep} setCurrentStep={setCurrentStep} />
      {currentStep === 0 ? (
        <CompanyData
          setCurrentStep={setCurrentStep}
          name={name}
          setName={setName}
          ruc={ruc}
          setRuc={setRuc}
          tradeName={tradeName}
          setTradeName={setTradeName}
          address={address}
          setAddress={setAddress}
          website={website}
          setWebsite={setWebsite}
        />
      ) : currentStep === 1 ? (
        <MainContact
          name={name}
          setName={setName}
          ruc={ruc}
          setRuc={setRuc}
          tradeName={tradeName}
          setTradeName={setTradeName}
          address={address}
          setAddress={setAddress}
          website={website}
          setWebsite={setWebsite}
          mainContact={mainContact}
          setMainContact={setMainContact}
          setCurrentStep={setCurrentStep}
          token={token}
        />
      ) : (
        <SuccessfulRegister />
      )}
    </div>
  );
};

export default RegisterNewCompanyPage;
